
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rolex",
      function () {
        return require("private-next-pages/rolex/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rolex"])
      });
    }
  